import React from 'react';

import TypeButton from './TypeButton/TypeButton';
import styles from './ConsultationTypes.module.css';
import langStrings from '../../../lang/languageStrings.json';

const typeSelection = (props) => {
  const audience_groups = [];

  const openLink = url => {
    window.open(url, '_blank').focus();
  }

  for (var i in props.audiences) {
    const audience = props.audiences[i];
    const audience_group = (
      <div key={audience} style={{width: '100%'}}>
        <h2 >{langStrings[props.language][audience]}</h2>
        <div className={styles.TypeContainer}>
        {
          props.consultationTypes.map(type => {
            if (type.audience === audience) {
              return (
                <TypeButton
                  className={styles.TypeContainer}
                  buttonHandler={props.buttonHandler}
                  typeId={type.id}
                  key={type.id}>
                    {type.label[props.language]}
                </TypeButton>
              )
            } else {
              return null;
            }
          })
        }
        </div>
      </div>
    );

    audience_groups.push(audience_group);
  }

  return (
    <div className={styles.ConsultationTypes}>
      <h1 style={{width:"100%"}}>{langStrings[props.language]["nav_consultation_config"]}</h1>
      {audience_groups}

      <h1 style={{width: '100%'}}>{langStrings[props.language]["other_consultations"]}</h1>
      <TypeButton
        className={styles.TypeContainer}
        buttonHandler={() => openLink("https://www.hs-rm.de/ueber-uns/organisation/hochschulverwaltung/studium-und-lehre/didaktik-und-digitale-lehre/mathematikdidaktik/mathe-helpdesk")}
        typeId={999}
        key={999}>
          Mathe Helpdesk
      </TypeButton>
      <TypeButton
        className={styles.TypeContainer}
        buttonHandler={() => openLink("https://www.hs-rm.de/studium/information-und-beratung/psychologische-beratung")}
        typeId={997}
        key={997}>
          Psychologische Beratung
      </TypeButton>
      <TypeButton
        className={styles.TypeContainer}
        buttonHandler={() => openLink("https://www.hs-rm.de/studium/information-und-beratung/studienberatung")}
        typeId={998}
        key={998}>
          Zentrale Studienberatung
      </TypeButton>
    </div>
  );
}

export default typeSelection;
